import React, { useState, useEffect } from "react"
import { useParams, useNavigate } from 'react-router-dom'
import axios from "axios"
import { FaBars, FaDownload } from 'react-icons/fa'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import Button from 'react-bootstrap/Button'
import { apiURL, sitePath } from 'config/globals'
import Sidebar from 'components/Sidebar'
import Footer from 'components/Footer'
import DataTable from 'components/DataTable'
import { capitalize } from 'utils/String'
import * as XLSX from 'xlsx'
import { checkAuth } from 'utils/Auth'
import moment from "moment"

const ViewDetails = () => {
    const [currentUser, setCurrentUser] = useState(false)
    const [viewData, setViewData] = useState([])
    const [tableColumns, setTableColumns] = useState([])
    const [tableData, setTableData] = useState()
    const { viewName } = useParams()
    const navigate = useNavigate()
    
    useEffect(() => {
        const start = async () => {
            setCurrentUser(await checkAuth(navigate))
            getView()
        }
        start()
    }, [])

    useEffect(() => {
        if (!viewData.rows) {
            return
        }
        setTableColumns(Object.keys(viewData.rows[0]).map(key => {
            return {
                Header: key,
                accessor: key
            }
        }))
        setTableData(viewData.rows)
    }, [viewData])

    const download = () => {
        const headers = tableColumns.map(tableCol => tableCol.Header)
        const rows = tableData.map(tableRow => 
            Object.keys(tableRow).map(key => tableRow[key])
        )
        const workbook = getWorkbook([headers].concat(rows))
        XLSX.writeFile(workbook, buildFileName(), {
            bookSST: true
        })
    }

    const buildFileName = () => {
        const date = moment().format('YYYY-MM-DD HH_mm')
        return `${date} ${viewName}.xlsx`
    }

    const getWorkbook = (rows) => {
        const worksheet =  XLSX.utils.aoa_to_sheet(rows)
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet)
        return workbook
    }

    const getView = async () => {
        const response = await axios.get(`${apiURL}/get-view/${viewName}`)
        //setViewData(beautify(response.data))
        setViewData(response.data)
    }

    const beautify = (data) => {
        data.rows.forEach(rowData => {
            Object.keys(rowData).forEach(key => {
                if (!rowData[key]) {
                    return
                }
                const words = rowData[key].split(" ")
                if (words.length > 10) {
                    rowData[key] = words.slice(0, 10).join(' ') + "..."
                }
            })
        })
        return data
    }

    return (
        <>
            <Sidebar selectedItem={`views/${viewName}`} currentUser={currentUser} />
            <main>
                <Breadcrumb>
                    <Breadcrumb.Item href={`${sitePath}/dashboard`}>Inici</Breadcrumb.Item>
                    <Breadcrumb.Item active>Vistes</Breadcrumb.Item>
                    <Breadcrumb.Item active>{capitalize(viewName)}</Breadcrumb.Item>
                </Breadcrumb>
                <div className="btn-toggle">
                    <FaBars />
                </div>
                <header>
                    <div className="float-start">
                        <h1>{capitalize(viewName)}</h1>
                    </div>
                    <Button variant="primary" className="float-end mt-2" onClick={download}>
                        <FaDownload />
                    </Button>
                </header>
                {viewData.rows && tableColumns && tableData
                    ? <>
                        <DataTable
                            columns={tableColumns}
                            data={tableData}
                            searchPlaceholder="Busca en aquesta vista"
                        />
                        <small>
                            {viewData.rows.length > 1
                                ? `${viewData.rows.length} registres`
                                : "1 registre"
                            }
                        </small>
                      </>
                    : <small>No hi han registres</small>
                }
                <Footer user={currentUser} />
            </main>
        </>
    )
}

export default ViewDetails